var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "checkbox-wrapper", attrs: { for: _vm.elementId } },
    [
      _vm._v(_vm._s(_vm.label) + "\n    "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newValue,
            expression: "newValue"
          }
        ],
        attrs: { id: _vm.elementId, name: _vm.elementId, type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.newValue)
            ? _vm._i(_vm.newValue, null) > -1
            : _vm.newValue
        },
        on: {
          change: function($event) {
            var $$a = _vm.newValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.newValue = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "custom-checkbox" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }